import useOKRBulkUploadPermissionsBasedOnEmployeeGoalsPrivileges from 'components/hooks/useOKRBulkUploadPermissionsBasedOnEmployeeGoalsPrivileges';
import useOKRConfig from 'components/hooks/useOKRConfig';
import { useSelectedView } from 'reducers/viewsSlice';

import { OBJECTIVE_TYPES_MAP } from 'constants/ProjectConstants';

// DON'T CONFUSE THIS HOOK WITH BULK UPLOAD ACCESS
// THIS HOOK IS USED TO DETERMINE IF THE BULK UPLOAD PANEL SHOULD BE SHOWN OR NOT
export const useBulkUploadPanelAccess = () => {
  const { id } = useSelectedView() ?? {};
  const isMyCompanyView = id === -1;
  const { OBJECTIVE_TYPE } = useOKRConfig();
  const { canBulkUploadObjectives, canBulkUploadKeyResults } =
    useOKRBulkUploadPermissionsBasedOnEmployeeGoalsPrivileges();

  const showBulkUploadObjectives =
    OBJECTIVE_TYPE !== OBJECTIVE_TYPES_MAP.DISABLED.value && canBulkUploadObjectives && isMyCompanyView;

  const showBulkUploadKeyResults = canBulkUploadKeyResults && isMyCompanyView;

  const bulkUploadObjectivesIsAccessible =
    OBJECTIVE_TYPE !== OBJECTIVE_TYPES_MAP.DISABLED.value && canBulkUploadObjectives;

  const bulkUploadKeyResultsIsAccessible = canBulkUploadKeyResults;

  return {
    showBulkUploadObjectives,
    showBulkUploadKeyResults,
    bulkUploadObjectivesIsAccessible,
    bulkUploadKeyResultsIsAccessible,
  };
};
